import React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import { __ } from '../../core/utils';
import CloseSmallIcon from '../../assets/images/close-small-15x15.svg';
import styles from '../../styles/flyouts/files/FileFlyout.scss';

const moduleLabel = (source) => {
  const labels = {
    tasks: __('Task'),
    tenders: __('Tender'),
    working_set_specifications: __('Specification'),
    plan_uploads: __('Plan'),
    working_set_plans: __('Plan'),
    current_set_plans: __('Plan'),
    products: __('Product'),
    meeting: __('Meeting'),
    stage: __('Stage'),
  };

  return labels[source.module_type] || source.module_type || '—';
};

const LinkedItems = ({ sources, collapsed, onUnlink }) => (
  <div className={classNames(styles.sectionContent, collapsed && styles.collapsed)}>
    {_.isEmpty(sources) ? (
      <div className={styles.empty}>
        {__('files.flyout.no-linked-items', {}, 'No linked items.')}
      </div>
    ) : (
      _.map(sources, (source) => (
        <div className={styles.linkedItem} key={source.link_id}>
          <span>{moduleLabel(source)}</span>
          <strong>
            {_.filter([source.code, source.title]).join(': ') || '—'}
          </strong>
          <button
            type='button'
            className={styles.unlink}
            onClick={(event) => {
              event.stopPropagation();
              onUnlink(source);
            }}
          >
            <CloseSmallIcon />
          </button>
        </div>
      ))
    )}
  </div>
);

export default LinkedItems;
